import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Auth } from '../models/auth.model';
import { UserInformation } from '../models/user-information';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
//import { CookieService } from 'angular2-cookie/core';

@Component({
  selector: 'auth',
  templateUrl: '../views/auth.html',
  providers: [AuthService]
})

export class AuthComponent{
  public title: string;
  public userInformation: UserInformation;
  public auth: Auth;
  public valid: boolean;

  constructor(
        private _authService: AuthService,
        private _route: ActivatedRoute,
        private _router: Router,
        public sharedVariables: VariableService,
      //  private cookie: CookieService
  )
  {
    this.title = "Auth module";
    this.auth = new Auth('','');
    this.valid = true;
  }

ngOnInit()
{
  console.log("Auth component initilized");
  this.sharedVariables.setCookie('user_id',0,1);
  //  this.cookie.put('test','test');
  //  console.log(this.cookie.get('test'));.
}

  onSubmit()
  {
    console.log('data to loaded',this.auth);
    this.validateUser();
  }

  validateUser()
  {
      this._authService.checkUser(this.auth).subscribe(
        response => {
          if(response.code == 200)
          {
            this.getUserID();
            setTimeout(()=> {
              this.sharedVariables.setCookie('username',this.auth.username,1);
              this.sharedVariables.setCookie('password',this.auth.password,1);
              this._router.navigate(['/menu-principal']);
            },this.sharedVariables.sessionTime);
          }else
          {
           this.valid = false;
          }
        },
        error => {
          console.log(<any>error);
        }
    );
  }

  getUserID()
  {
    this._authService.getUserID(this.auth.username,this.auth.password).subscribe(
      response => {
        if(response.code == 200)
        {
          this.sharedVariables.setCookie('user_id',response.data[0].ID,1);
          console.log(response.data[0].ID);
        }else
        {

        }
      },
      error => {
        console.log(<any>error);
      }
  );
  }

}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/auth.component.ts